import React from "react";
import useFormActions from "../useFormActions";
import StepWrapper from "./StepWrapper";
import { DropdownField } from "../../common/forms/components/DropdownField";
import { INDUSTRY_TYPE_KEY } from "../../common/forms/constants";
import { useForm } from "react-hook-form";
import useFormState from "../useFormState";
import { SOURCE_SUBMIT } from "../Subscription";
import { subscriptionStepProps } from "../../common/types/subscription";

export default function Step4({
	formStep,
	subtitle,
	title,
}: subscriptionStepProps) {
	const { onUpdateField, onUpdateForm, onSubmitForm } = useFormActions();
	const { control, handleSubmit } = useForm();
	const { userExists } = useFormState();

	const handleFormSubmit = (data) => {
		onUpdateForm(data);
		userExists && onSubmitForm(SOURCE_SUBMIT, "subscribe-email");
	};

	return (
		<StepWrapper
			formStep={formStep}
			onSubmit={handleSubmit((data) => handleFormSubmit(data))}
			title={title}
			subtitle={subtitle}
		>
			<DropdownField
				choicesEndpoint="industry_type"
				control={control}
				dropdownToggle="Please select your industry type"
				label="Industry Type"
				name={INDUSTRY_TYPE_KEY}
				onFieldChange={onUpdateField}
				required
			/>
		</StepWrapper>
	);
}
